import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../services/axios';
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import Table from '../../common/table';
import TablePop from '../../common/table-pop';
import { userRole, blobType } from '../../../constants/appConst';
import Swal from "sweetalert2";
import { getFileIconName } from '../../../lib/common';
import { hasFolderRole } from "../../../lib/permissionHelper";

const TableMainContent = ({
    folderId,
    refreshTriggred,
    renameCallBack,
    editCallBack,
    idPath 
}) => {
    const [data, setData] = useState([]);
    const [itemPerPage, setItemPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const { user, refreshFolders } = useJWTAuth();
    const getData = async () => {
        try {
            setIsLoading(true)
            const { data } = await api.get("/Files/GetFilesAndFoldersFromParentId?FolderId=" + folderId + "&PageNumber=" + currentPage + "&PageSize=" + itemPerPage + "&SearchText=" + searchText);
            setData(data.result.items);
            setTotalPages(data.result.totalPages)
            setTotalCount(data.result.totalCount)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        if (folderId) {
            getData();
        }
    }, [folderId, refreshTriggred, itemPerPage, currentPage, searchText]);

    const tablePopCallback = async (val, name) => {
        try {
            const response = await api.get("files/ExportFiles?BlobGuid=" + val, { responseType: 'blob' });

            if (response.data.type && response.data.type.includes('json')) {
                const text = await response.data.text();
                const json = JSON.parse(text);

                if (json.isSas) {
                    const link = document.createElement('a');
                    link.href = json.url;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    return;
                }
            }

            const blobURL = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = blobURL;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobURL);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    // const tablePopCallback = async (val, name) => {
    //     try {
    //         const response = await api.get("files/ExportFiles?BlobGuid=" + val, { responseType: 'blob', });
    //         // Create a blob URL for the file
    //         const blobURL = window.URL.createObjectURL(new Blob([response.data]));
    //         const link = document.createElement('a');
    //         link.href = blobURL;
    //         link.setAttribute('download', name);
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         window.URL.revokeObjectURL(blobURL);
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // }

    const DeleteLink = async (id) => {
        Swal.fire({
            text: 'Are you sure you want to delete the link?',
            icon: 'warning',
            confirmButtonText: 'Delete',
            showDenyButton: true,
            denyButtonText: 'Cancel',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { data } = await api.delete("Link/DeleteLink?LinkIdentifier=" + id);
                    if (data.statusCode === 200) {
                        Swal.fire({
                            position: "center",
                            text: "Link deleted successfully",
                            confirmButtonText: "Ok",
                            icon: 'info',
                            timer: 3000,
                            timerProgressBar: true
                        }).then(val => getData());
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        })
    }

    const DeleteFile = async (id) => {
        Swal.fire({
            text: 'Are you sure you want to delete the file? You might permanently lose all data',
            icon: 'warning',
            confirmButtonText: 'Delete',
            showDenyButton: true,
            denyButtonText: 'Cancel',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { data } = await api.delete("Files?BlobGuid=" + id);
                    if (data.statusCode === 200) {
                        Swal.fire({
                            position: "center",
                            text: "File deleted successfully",
                            confirmButtonText: "Ok",
                            icon: 'info',
                            timer: 3000,
                            timerProgressBar: true
                        }).then(val => getData());
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        })
    }



    const DeleteFolder = async (id) => {
        Swal.fire({
            text: 'Are you sure you want to delete the folder? You might permanently lose all files and subfolders',
            icon: 'warning',
            confirmButtonText: 'Delete',
            showDenyButton: true,
            denyButtonText: 'Cancel',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                refreshFolders();
                try {
                    const { data } = await api.delete("Folders?FolderGuid=" + id);
                    if (data.statusCode === 200) {
                        Swal.fire({
                            position: "center",
                            icon: 'info',
                            text: "Folder deleted successfully",
                            confirmButtonText: "Ok",
                            timer: 3000,
                            timerProgressBar: true
                        }).then(val => getData());
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        })
    }
    const columns = [
        {
            key: 'name',
            title: 'Name',
            width: '30%',
            render: (item, index) => (
                <>
                    {
                        item.type === blobType.File ? <div className='table-file' onClick={() => { tablePopCallback(item.identifier, item.name) }}><img src={`/Assets/${getFileIconName(item.name.substring(item.name.lastIndexOf('.') + 1))}.svg`} alt="DropDown Symbol" /><span><u>{item.name}</u></span></div>
                            :
                            item.type === blobType.Folder ? <div className='table-folder' onClick={() => {
                                setSearchText(''); setCurrentPage(1); navigate('/' + item.identifier);
                            }}>

                                <img src="/Assets/folder-icon.svg" alt="DropDown Symbol" /><span>{item.name}</span>
                            </div>
                                : <div className='table-link'>
                                    <span> <img src="/Assets/link.svg" alt="link" /><a href={item.path} target='_blank' alt="Link" rel="noreferrer">{item.name}</a></span>
                                </div>
                    }
                </>
            ),
        }, {
            key: 'lastModifiedByName',
            title: 'Opened by',
            width: '20%',
        }, {
            key: 'createdByName',
            title: 'Upload by',
            width: '20%',
        }, {
            key: 'created',
            title: 'Uploaded Date',
            width: '20%',
            render: (item, index) => (
                <>
                    {
                        new Date(item.created).toLocaleString()
                    }
                </>
            ),
        }, {
            key: 'id',
            title: 'Action',
            width: '10%',
            render: (item, index) => (
                <>
                    {
                        <TablePop>
                            {
                                item.type === blobType.File ? <div onClick={() => { tablePopCallback(item.identifier, item.name) }} className='mb-2'><span className='pop-img'><img src='/Assets/download.svg' alt='download' /></span>Download</div>
                                    : null
                            }
                            <div onClick={() => {

                                navigator.clipboard.writeText(item.type === blobType.File ? window.origin + '/ExportFiles/' + item.identifier : item.type === blobType.Folder ? window.origin + '/' + item.identifier : item.path)
                                var text = '';
                                if (item.type === blobType.File) {
                                    text = "File url successfully copied to clipboard!"
                                }
                                else if (item.type === blobType.Folder) {
                                    text = "Folder url successfully copied to clipboard!";
                                }
                                else {
                                    text = "Link url successfully copied to clipboard!";
                                }
                                Swal.fire({
                                    text: text,
                                    icon: "success",
                                    timer: 3000,
                                    timerProgressBar: true
                                });
                            }} className='mb-2'><span className='pop-img'><img src='/Assets/copy.svg' alt='copy' /></span>Copy link</div>
                            {
                                (hasFolderRole(
                                    user,
                                    folderId,
                                    idPath,
                                    userRole.BusinessUnitAdmin
                                )) ?
                                    (<><div className='mb-2' onClick={() => { item.type === blobType.File ? DeleteFile(item.identifier) : item.type === blobType.Link ? DeleteLink(item.identifier) : DeleteFolder(item.identifier) }}><span className='pop-img'><img src='/Assets/delete-icon.svg' alt='delete' /></span>Delete</div>
                                        <div className='mb-2' onClick={() => renameCallBack(item.identifier, item.name, item.type)}><span className='pop-img'><img src='/Assets/edit.svg' alt='rename' /></span>Rename</div>
                                        {item.type === blobType.Link ? <div className='mb-2' onClick={() => editCallBack(item.identifier, item.name, item.path, item.type)}><span className='pop-img'><img src='/Assets/edit.svg' alt='edit' /></span>Edit</div> : null}</>)
                                    : null
                            }
                        </TablePop>
                    }
                </>
            ),
        }
    ]
    return (
        <>
            <Table isLoading={isLoading} columns={columns} data={data} handleItemsPerPageChange={(e) => setItemPerPage(e)} totalPages={totalPages}
                handleSearchChange={(e) => setSearchText(e)} currentPage={currentPage} itemsPerPage={itemPerPage}
                paginationEnabled={true} handleClickPageNumber={(e) => setCurrentPage(e)} totalItems={totalCount} />
        </>
    )
}
export default TableMainContent;